import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import clone from 'clone'
import { formatDisplayDate, formatDisplayDateTime2, formatDisplayDateTime4, removeTime } from '@/utils/date'
import { formatPrice } from '@/utils/index'
import { removeFormatNumber } from '@/utils/number'
import { recordLockMixin } from '@/mixins/common/recordLockMixin'

export const mulAcctPaymentAjaxMixin = {
  data() {
    return {
    }
  },
  created() {
    // AR: Initialize CommonUtil Menu 29-Jan-2021
    this.initCommonUtilMenu()
  },
  methods: {
    async performSearchMultAcctPayt() {
      const apiUrl = this.$store.state.payment.menu.performSearchMultiAcct
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          const paramMap = {
            page: page - 1,
            size: itemsPerPage
          }
          let messageFilters = clone(this.mulAcctPayFilterForm)

          if (messageFilters.transactionDateFrom !== null && messageFilters.transactionDateFrom !== '') {
            messageFilters.transactionDateFrom = formatDisplayDateTime2(removeTime(messageFilters.transactionDateFrom))
          }

          if (messageFilters.transactionDateTo !== null && messageFilters.transactionDateTo !== '') {
            messageFilters.transactionDateTo = formatDisplayDateTime2(removeTime(messageFilters.transactionDateTo))
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, paramMap), messageFilters, this.pagination.sortBy, this.pagination.sortDesc))
          const { data } = result.data
          if (data) {
            this.totalItems = result.data.totalElements
            this.items = []
            data.map((result) => {
              const resultList = {
                branch: result.branch,
                accountNo: result.acctNo,
                documentNo: result.docNo,
                suffix: result.suffix,
                fund: result.fund,
                type: result.type,
                tranDate: this.formatDate(result.tranDate),
                currency: result.curr,
                amount: formatPrice(result.debitAmt),
                gst: formatPrice(result.othGST),
                bankOrigAmt: formatPrice(result.bankOrigAmt),
                bankLocTot: formatPrice(result.bankLocTotal)
              }
              this.items.push(resultList)
            })
          } else {
            this.items = []
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        } finally {
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        this.loading = false
      }
    },
    async performReviewMultAcctPayt() {
      const apiURI = this.$store.state.payment.menu.performActionMultiAcct
      if (apiURI) {
        try {
          this.mulAcctPayForm.actionName = 'MULTIPLE_PAYMENT_REVIEW'
          this.mulAcctPayForm.branch = this.paymentData.branch
          this.mulAcctPayForm.transactionType = this.paymentData.type
          this.mulAcctPayForm.documentNo = this.paymentData.documentNo
          const result = await this.$http.post(apiURI, this.mulAcctPayForm)
          const { data } = result
          var counter = 0
          if (data.data.length > 0) {
            data.data.map((mulAcctPayment) => {
              const mulAcctPaymentList = {
                branch: mulAcctPayment.branch,
                accountNo: mulAcctPayment.accountNo,
                documentNo: mulAcctPayment.documentNo,
                transactionType: mulAcctPayment.transactionType,
                docAE: mulAcctPayment.docAE,
                transactionDate: mulAcctPayment.transactionDate,
                payTo: mulAcctPayment.payTo,
                bankNo: mulAcctPayment.bankNo,
                fromBank: mulAcctPayment.bankNo,
                fund: mulAcctPayment.fund,
                accountNoSuffix: mulAcctPayment.accountNoSuffix,
                cashBook: mulAcctPayment.cashBook,
                gstIO: mulAcctPayment.gstIO,
                gstStatus: mulAcctPayment.gstStatus,
                gstRate: mulAcctPayment.gstRate,
                amountCurr: mulAcctPayment.amountCurr,
                amount: formatPrice(mulAcctPayment.amount),
                gstAmountCurr: mulAcctPayment.gstAmountCurr,
                amountCurrRate: mulAcctPayment.amountCurrRate,
                gstAmountAE: mulAcctPayment.gstAmountAE === 'true' ? 'A' : 'E',
                gstAmount: formatPrice(mulAcctPayment.gstAmount),
                netAmountCurr: mulAcctPayment.netAmountCurr,
                netAmount: formatPrice(mulAcctPayment.netAmount),
                bankAmountCurr: mulAcctPayment.bankAmountCurr,
                bankAmountAE: mulAcctPayment.bankAmountAE === 'true' ? 'A' : 'E',
                bankAmount: formatPrice(mulAcctPayment.bankAmount),
                bankAmountCurrRate: mulAcctPayment.bankAmountCurrRate,
                bankChargesCurr: mulAcctPayment.bankChargesCurr,
                bankCharges: formatPrice(mulAcctPayment.bankCharges),
                bankTotalAmountCurr: mulAcctPayment.bankTotalAmountCurr,
                bankTotalAmount: formatPrice(Number(removeFormatNumber(mulAcctPayment.bankAmount)) + Number(removeFormatNumber(mulAcctPayment.bankCharges))),
                bankTotalLocalCurr: mulAcctPayment.bankTotalLocalCurr,
                bankTotalLocalAE: mulAcctPayment.bankTotalLocalAE === 'true' ? 'A' : 'E',
                bankTotalLocal: formatPrice(mulAcctPayment.bankTotalLocal),
                bankTotalLocalCurrRate: mulAcctPayment.bankTotalLocalCurrRate,
                chequeNo: mulAcctPayment.chequeNo,
                prtCheque: mulAcctPayment.prtCheque === 'true',
                isDeptMand: mulAcctPayment.isDeptMand,
                printDocument: mulAcctPayment.printDocument,
                policyNo: mulAcctPayment.polNo !== null ? mulAcctPayment.polNo + mulAcctPayment.renCnt + '-' + mulAcctPayment.endtCnt : '',
                insdRefNo: mulAcctPayment.insdRefNo,
                companyName: mulAcctPayment.companyName,
                docAddress1: mulAcctPayment.docAddress1,
                docAddress2: mulAcctPayment.docAddress2,
                docAddress3: mulAcctPayment.docAddress3,
                docAddress4: mulAcctPayment.docAddress4,
                postalCode: mulAcctPayment.postalCode,
                details: mulAcctPayment.details,
                statementRef: mulAcctPayment.statementRef,
                department: mulAcctPayment.department,
                insuredName: mulAcctPayment.insuredName,
                claimNo: mulAcctPayment.claimNo,
                gstRegNo: mulAcctPayment.gstRegNo,
                taxInvoiceNo: mulAcctPayment.taxInvoiceNo,
                saveStatus: 'false',
                createdBy: mulAcctPayment.createdBy,
                createdDate: formatDisplayDateTime4(mulAcctPayment.createdDate),
                modifiedBy: mulAcctPayment.modifiedBy,
                modifiedDate: formatDisplayDateTime4(mulAcctPayment.modifiedDate)
              }
              this.accountList.push(mulAcctPaymentList)
              counter = counter + 1

              if (counter === 1 && this.paymentData.tranMode !== 'Q') {
                this.defaultForm.branch = mulAcctPayment.branch
                this.defaultForm.documentNo = mulAcctPayment.documentNo
                this.defaultForm.transactionType = mulAcctPayment.transactionType
                this.defaultForm.docAE = mulAcctPayment.docAE === 'true'
                this.defaultForm.transactionDate = mulAcctPayment.transactionDate
                this.defaultForm.chequeNo = mulAcctPayment.chequeNo
                this.defaultForm.prtCheque = mulAcctPayment.prtCheque
                this.defaultForm.fromBank = mulAcctPayment.bankNo
                this.defaultForm.fund = mulAcctPayment.fund
                this.defaultForm.gstIO = mulAcctPayment.gstIO
                this.defaultForm.gstStatus = mulAcctPayment.gstStatus
                this.defaultForm.gstRate = mulAcctPayment.gstRate
                this.defaultForm.amountCurr = mulAcctPayment.amountCurr
                this.defaultForm.bankAmountCurr = mulAcctPayment.bankAmountCurr
                this.defaultForm.bankAmountCurrRate = mulAcctPayment.bankAmountCurrRate
                this.defaultForm.bankChargesCurr = mulAcctPayment.bankChargesCurr
                this.defaultForm.bankTotalAmountCurr = mulAcctPayment.bankTotalAmountCurr
                this.defaultForm.bankTotalLocalCurr = mulAcctPayment.bankTotalLocalCurr
                this.defaultForm.printDocument = mulAcctPayment.printDocument
                this.defaultForm.amountCurrRate = mulAcctPayment.amountCurrRate
                this.initDisabled = true
                this.doReview(mulAcctPaymentList)
              } else if (counter === 1 && this.paymentData.tranMode === 'Q') {
                this.doQuery(mulAcctPaymentList)
              }
            })
            this.doAccumulate()
          }
        } catch (err) {
          const { data } = err.response
          this.showPromptLeave = true
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.showPromptLeave = true
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async performSaveMultAcctPayt() {
      const apiURI = this.$store.state.payment.menu.performActionMultiAcct
      if (apiURI) {
        try {
          let messageFilters = clone(this.mulAcctPayForm)
          for (var i = 0; i < messageFilters.accountList.length; i++) {
            if (messageFilters.accountList[i].transactionDate !== '') {
              messageFilters.accountList[i].transactionDate = formatDisplayDate(messageFilters.accountList[i].transactionDate)
            }
          }
          const result = await this.$http.post(apiURI, messageFilters)
          const { data } = result
          if (data) {
            if (messageFilters.actionName === 'CREATE_SAVE_POST' || messageFilters.actionName === 'UPDATE_SAVE_POST') {
              for (var ii = 0; ii < messageFilters.accountList.length; ii++) {
                if (messageFilters.accountList[ii].printDocument === 'I') {
                  const commit = {
                    branch: messageFilters.accountList[ii].branch,
                    accountNo: messageFilters.accountList[ii].accountNo,
                    type: messageFilters.accountList[ii].transactionType,
                    documentNo: data.resultMap.documentNo,
                    fund: messageFilters.accountList[ii].fund,
                    suffix: messageFilters.accountList[ii].accountNoSuffix,
                    actionName: messageFilters.actionName,
                    printDoc: 'I'
                  }
                  this.doExportAcctPaytDoc(commit)
                }
              }
            }
            // // AR: OS-660 Unlock Record upon exit 29-Jan-2021
            let recKey = 'MUL|' + this.mulAcctPayForm.transactionType + '|' +
                        this.mulAcctPayForm.branch + '|' +
                        this.mulAcctPayForm.documentNo + '|' +
                        this.mulAcctPayForm.fund
            this.unlockRecord(recKey, 'ACT')
            this.doExit()
            this.notify(data)
            this.$router.push({ name: 'mulAcctPayment' })
          }
        } catch (err) {
          const { data } = err.response
          this.showPromptLeave = true
          if (data) {
            this.processingFlag = false
            this.message(data)
            this.fieldMessage(data)
          }
          this.processingFlag = false
        }
      } else {
        this.showPromptLeave = true
        this.processingFlag = false
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async ValidatePolicyNo(polNo, acctNo) {
      const apiUrl = this.$store.state.payment.menu.validatePolicyNo
      if (apiUrl) {
        try {
          const params = {
            polNo: polNo,
            acctNo: acctNo
          }
          const result = await this.$http.get(expandURI(apiUrl, params))
          const { data } = result.data
          if (data) {
          }
          return true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
          return false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        return false
      }
    },
    async delMultAcctPayt(data) {
      const apiUrl = this.$store.state.payment.menu.delMultAcctPayt
      try {
        const requestParams = data
        if (apiUrl) {
          this.$http.post(apiUrl, requestParams).then(result => {
            const data = result.data
            this.notify(data)
            this.doClearFilters()
          }).catch(err => {
            const { data } = err.response
            if (data) {
              this.notify(data)
            }
          })
        }
      } catch (err) {
        const { data } = err.response
        if (data) {
          this.notify(data)
        }
      }
    },
    async fetchBranch() {
      this.branches = []
      let apiUrl = this.$store.state.payment.menu.fetchBranch
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.branches.push(data)
              })
            }
          }
        })
      }
    },
    async fetchAccount() {
      this.accounts = []
      let apiUrl = this.$store.state.payment.menu.fetchAccount
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.accounts.push(data)
              })
            }
          }
        })
      }
    },
    async fetchFund() {
      this.funds = []
      let apiUrl = this.$store.state.payment.menu.fetchFund
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.funds.push(data)
              })
            }
          }
        })
      }
    },
    async fetchBank() {
      this.banks = []
      let apiUrl = this.$store.state.payment.menu.fetchBank
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.banks.push(data)
              })
            }
          }
        })
      }
    },
    async fetchAcctNoSfx() {
      this.acctnosuffixes = []
      let apiUrl = this.$store.state.payment.menu.fetchAcctNoSfx
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.acctnosuffixes.push(data)
              })
            }
          }
        })
      }
    },
    async fetchGstStatus() {
      this.gstStatuses = []
      let apiUrl = this.$store.state.payment.menu.fetchGstStatus
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.gstStatuses.push(data)
              })
            }
          }
        })
      }
    },
    async fetchCurrency() {
      this.currencies = []
      let apiUrl = this.$store.state.payment.menu.fetchCurrency
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.currencies.push(data)
              })
            }
          }
        })
      }
    },
    async fetchAmountCurrency() {
      this.amountcurrencies = []
      let apiUrl = this.$store.state.payment.menu.fetchAmountCurrency
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.amountcurrencies.push(data)
              })
            }
          }
        })
      }
    },
    async fetchDepartment() {
      this.departments = []
      let apiUrl = this.$store.state.payment.menu.fetchDepartment
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.departments.push(data)
              })
            }
          }
        })
      }
    },
    async fetchCashBook() {
      this.cashbooks = []
      let apiUrl = this.$store.state.payment.menu.fetchCashBook
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.cashbooks.push(data)
              })
            }
          }
        })
      }
    },
    async fetchUserDetails(userid) {
      let username = '-'
      let apiUrl = this.$store.state.payment.menu.fetchUserDetails
      if (apiUrl) {
        const expand = {
          userId: userid
        }
        await this.$http.get(expandURI(apiUrl, expand)).then(result => {
          if (result.data) {
            const data = result.data.dataMap
            const { userDetails } = data
            username = userDetails.firstName
            if (userDetails.lastName !== null || userDetails.lastName !== '') {
              username = username + ' ' + userDetails.lastName
            }
          }
        })
      }
      return username
    }
  },
  mixins: [
    MessageMixin,
    recordLockMixin
  ]
}
